import { combineReducers } from 'redux';
import app from './app';
import networkHealth from './networkHealth';

export default combineReducers({
	app,
	networkHealth
});



// WEBPACK FOOTER //
// ./src/reducers/reducer.js